/**
 * @file category-header-options.ts
 * @description Реестры группы «Шапка категории» панели «Каталог → Список»
 * (phase19.16 Р2а; решение пользователя 2026-10-12 «Да» — баннеру категории
 * тот же выбор показа, что у обложки ленты блога): виды шапки
 * (`categoryHeader`) и раскладки баннера (`categoryBanner.layout`) — подпись
 * карточки-схемы и слово для сводки свёрнутой группы. Один список на поле
 * (`CategoryHeaderGroup`, `CategoryBannerFields`) и сводку (`CatalogListTab`).
 */

import type { SiteCatalogOptions } from "@chaiberi/shared";

type Header = SiteCatalogOptions["categoryHeader"];
type BannerLayout = SiteCatalogOptions["categoryBanner"]["layout"];

export const CATEGORY_HEADERS: ReadonlyArray<{ value: Header; label: string; short: string }> = [
  { value: "title", label: "Только заголовок", short: "только заголовок" },
  { value: "title-description", label: "С описанием", short: "с описанием" },
  { value: "banner", label: "Баннер", short: "баннер" },
];

export const CATEGORY_BANNER_LAYOUTS: ReadonlyArray<{ value: BannerLayout; label: string; short: string }> = [
  { value: "background", label: "Фоном во всю ширину", short: "фоном" },
  { value: "side-right", label: "Фото справа", short: "фото справа" },
  { value: "side-left", label: "Фото слева", short: "фото слева" },
];

/** Пояснение к неактивным полям баннера при шапке без фото. */
export const BANNER_OFF_NOTE = "Действуют только при шапке «Баннер».";

/** Пояснение к неактивным затемнению и тону при фото сбоку. */
export const BANNER_SIDE_NOTE = "Действуют только при фото фоном.";

/**
 * Пояснение к светлому тексту без затемнения. У баннера категории это
 * умолчание (затемнение 0 — как было до настройки), а на витрине под текстом
 * всегда есть градиент снизу, поэтому тон — справка (info), не предупреждение.
 */
export const BANNER_LOW_DIM_NOTE = "Под текстом есть градиент снизу; если фото светлое, добавьте затемнение или выберите тёмный текст.";

/** Сводка группы: «баннер · фоном», «с описанием», «только заголовок». */
export function categoryHeaderSummary(o: SiteCatalogOptions): string {
  const header = CATEGORY_HEADERS.find((h) => h.value === o.categoryHeader)?.short ?? "";
  if (o.categoryHeader !== "banner") return header;
  const layout = CATEGORY_BANNER_LAYOUTS.find((l) => l.value === o.categoryBanner.layout)?.short ?? "";
  return `${header} · ${layout}`;
}
